module.exports = __webpack_public_path__ + "img/menu-qianshuhetong.22139e3e.png";